// extracted by mini-css-extract-plugin
module.exports = {"root":"customAttributes_root__2L66q","list":"customAttributes_list__IwpO8 list-disc mb-4 mt-4 pl-6"};